exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\n\n// ---------------------- phone mediaq\n\t@include media($phone) {\n\t}\n// ---------------------- tablet mediaq\n\t@include media($tablet) {\n\t}\n// ---------------------- desktop mediaq\n\t@include media($desktop) {\n\t}\n\n*/\n.Form {\n  width: 100%;\n  float: left; }\n  .Form__Wrap {\n    padding: 32px 20px 20px 20px; }\n  .Form__Note {\n    margin: 0;\n    font-size: 14px;\n    text-align: center;\n    width: 100%;\n    clear: both; }\n    .Form__Note a {\n      font-weight: 700; }\n", ""]);

// exports
